(function () {
  if (window.__facetExpandAllBound) return;
  window.__facetExpandAllBound = true;

  var FACETS_ADVANCED_OPEN_STORAGE_KEY = 'facetsAdvancedOpenState';

  function getAdvancedFacetStorageScope() {
    return window.location.pathname;
  }

  function getAdvancedFacetLabel(filter) {
    return (filter.querySelector('.facets__summary-label, .body-title-m') || {}).textContent?.trim?.() || '';
  }

  function readAdvancedFacetOpenState() {
    try {
      var rawState = localStorage.getItem(FACETS_ADVANCED_OPEN_STORAGE_KEY);
      return rawState ? JSON.parse(rawState) : {};
    } catch (_) {
      return {};
    }
  }

  function writeAdvancedFacetOpenState(state) {
    try {
      localStorage.setItem(FACETS_ADVANCED_OPEN_STORAGE_KEY, JSON.stringify(state));
    } catch (_) {}
  }

  function persistExpandAllAdvancedFacetState(form, open) {
    var scope = getAdvancedFacetStorageScope();
    var state = readAdvancedFacetOpenState();

    if (open) {
      state[scope] = Array.from(form.querySelectorAll('.js-filter[data-advanced-filter="true"]'))
        .map(getAdvancedFacetLabel)
        .filter(Boolean);
    } else {
      state[scope] = [];
    }

    writeAdvancedFacetOpenState(state);
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-facet-expand-toggle]');
    if (!toggleBtn) return;

    var btn = toggleBtn;
    var form = btn.closest('form');
    if (!form) return;

    var nextExpanded = btn.getAttribute('aria-pressed') !== 'true';
    var open = nextExpanded;
    persistExpandAllAdvancedFacetState(form, open);

    form.querySelectorAll('.js-filter').forEach(function (filter) {
      if (open) {
        filter.setAttribute('open', '');
      } else {
        filter.removeAttribute('open');
      }
      var summary = filter.querySelector('.facets__summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    btn.setAttribute('aria-pressed', nextExpanded ? 'true' : 'false');
    var label = nextExpanded ? btn.getAttribute('data-label-collapse') : btn.getAttribute('data-label-expand');
    if (label) btn.textContent = label;
  });
})();
